// Share the logged-in session across browser tabs.
//
// The app stores auth in sessionStorage (per-tab), so opening a link in a NEW
// tab logged the user out. This module — imported FIRST in index.js so it runs
// before any reducer/i18n reads storage — hydrates sessionStorage from
// localStorage on load and mirrors every write back to localStorage, so a new
// tab inherits the session. logout() calls sessionStorage.clear(), which now
// also clears localStorage, so logging out still ends the session everywhere.
(function shareSessionAcrossTabs() {
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k !== null && sessionStorage.getItem(k) === null) {
        sessionStorage.setItem(k, localStorage.getItem(k));
      }
    }
    const origSet = window.sessionStorage.setItem.bind(window.sessionStorage);
    const origRemove = window.sessionStorage.removeItem.bind(
      window.sessionStorage
    );
    const origClear = window.sessionStorage.clear.bind(window.sessionStorage);
    window.sessionStorage.setItem = (k, v) => {
      origSet(k, v);
      try {
        localStorage.setItem(k, v);
      } catch (e) {}
    };
    window.sessionStorage.removeItem = (k) => {
      origRemove(k);
      try {
        localStorage.removeItem(k);
      } catch (e) {}
    };
    window.sessionStorage.clear = () => {
      origClear();
      try {
        localStorage.clear();
      } catch (e) {}
    };
  } catch (e) {
    /* storage unavailable — ignore */
  }
})();
